<div class="app" fxLayout="column">
    <!-- Top bar -->
    <div class="topbar" *ngIf="showLayout">
        <ce-topbar [pageId]="pageId$ | async"></ce-topbar>
        <div class="global-loading">
            <mat-progress-bar [class.hidden]="!showGlobalLoading" mode="indeterminate"></mat-progress-bar>
        </div>
    </div>

    <div class="app-content" fxFlex fxLayout="row">
        <!-- Side navigation -->
        <div class="sidenav" *ngIf="showLayout">
            <ce-sidenav [mode]="(isMobile$ | async) ? 'hidden' : 'collapsed'"></ce-sidenav>
        </div>

        <!-- Page content -->
        <div class="page" [ngClass]="pageId$ | async" fxFlex>
            <ng-content></ng-content>
        </div>
    </div>
</div>
